module.exports = __webpack_public_path__ + "img/022.0a081d96.png";